var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "18px",
    viewBox: "0 0 19 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Call_icon_tag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets_Export",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "call-black-18dp",
    transform: "translate(0.116667, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 18 0 18 18 0 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3868966,11.2537931 C14.4537931,11.2537931 13.5510345,11.102069 12.7089655,10.8289655 C12.4434483,10.737931 12.1475862,10.8062069 11.9427586,11.0110345 L10.7517241,12.5055172 C8.60482759,11.4813793 6.59448276,9.54689655 5.52482759,7.32413793 L7.00413793,6.06482759 C7.20896552,5.85241379 7.26965517,5.55655172 7.1862069,5.29103448 C6.90551724,4.44896552 6.76137931,3.5462069 6.76137931,2.61310345 C6.76137931,2.20344828 6.42,1.86206897 6.01034483,1.86206897 L3.38551724,1.86206897 C2.97586207,1.86206897 2.48275862,2.04413793 2.48275862,2.61310345 C2.48275862,9.66068966 8.34689655,15.5172414 15.3868966,15.5172414 C15.9255172,15.5172414 16.137931,15.0393103 16.137931,14.622069 L16.137931,12.0048276 C16.137931,11.5951724 15.7965517,11.2537931 15.3868966,11.2537931 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.d8b7a6750dc3a7812e87ef8317b1df4a.svg";
export { ForwardRef as ReactComponent };